var _div, _div2;
import React from 'react';

/**
 *  The InventoryListingPlaceholder is used to preserve space for anticipated listing elements that maybe loaded
 *  after initial render has completed.
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function InventoryListingPlaceholder(_ref, ref) {
  let {
    orientation = 'portrait',
    ...rest
  } = _ref;
  if (orientation === 'landscape') {
    return /*#__PURE__*/_jsx("div", {
      "data-cmp": "inventoryListingPlaceholder",
      ref: ref,
      ...rest,
      children: /*#__PURE__*/_jsx("div", {
        className: "inventory-listing cursor-pointer display-flex flex-column panel panel-default",
        children: /*#__PURE__*/_jsxs("div", {
          className: "item-card display-flex skeleton__listing skeleton__loading",
          children: [/*#__PURE__*/_jsx("div", {
            className: "padding-0 margin-bottom-3 margin-bottom-sm-0",
            children: /*#__PURE__*/_jsx("div", {
              className: "skeleton__image skeleton__placeholder",
              style: {
                height: '200px',
                width: '266px'
              }
            })
          }), _div || (_div = /*#__PURE__*/_jsxs("div", {
            className: "col-sm-8 col-md-8 col-lg-9 padding-horizontal-4 padding-top-3",
            children: [/*#__PURE__*/_jsxs("div", {
              className: "row",
              children: [/*#__PURE__*/_jsx("div", {
                className: "col-xs-7 col-sm-5",
                children: /*#__PURE__*/_jsx("div", {
                  className: "skeleton__headline skeleton__placeholder"
                })
              }), /*#__PURE__*/_jsx("div", {
                className: "col-xs-3 col-sm-2 col-xs-offset-2 col-sm-offset-5",
                children: /*#__PURE__*/_jsx("div", {
                  className: "skeleton__text skeleton__placeholder"
                })
              })]
            }), /*#__PURE__*/_jsxs("div", {
              className: "row",
              children: [/*#__PURE__*/_jsx("div", {
                className: "col-xs-7 col-sm-5",
                children: /*#__PURE__*/_jsx("div", {
                  className: "skeleton__text skeleton__placeholder"
                })
              }), /*#__PURE__*/_jsx("div", {
                className: "col-xs-3 col-sm-2 col-xs-offset-2 col-sm-offset-5",
                children: /*#__PURE__*/_jsx("div", {
                  className: "skeleton__text skeleton__placeholder"
                })
              })]
            }), /*#__PURE__*/_jsxs("div", {
              className: "row",
              children: [/*#__PURE__*/_jsx("div", {
                className: "col-xs-5 col-sm-3",
                children: /*#__PURE__*/_jsx("div", {
                  className: "skeleton__headline skeleton__placeholder"
                })
              }), /*#__PURE__*/_jsx("div", {
                className: "col-xs-2 col-sm-1 col-xs-offset-5 col-sm-offset-8",
                children: /*#__PURE__*/_jsx("div", {
                  className: "skeleton__text skeleton__placeholder"
                })
              })]
            }), /*#__PURE__*/_jsx("div", {
              className: "row",
              children: /*#__PURE__*/_jsx("div", {
                className: "col-xs-12",
                children: /*#__PURE__*/_jsx("div", {
                  className: "skeleton__spacer"
                })
              })
            }), /*#__PURE__*/_jsxs("div", {
              className: "row",
              children: [/*#__PURE__*/_jsx("div", {
                className: "col-xs-10 col-md-5",
                children: /*#__PURE__*/_jsx("div", {
                  className: "skeleton__text skeleton__placeholder"
                })
              }), /*#__PURE__*/_jsx("div", {
                className: "col-xs-8 col-md-3 col-lg-4",
                children: /*#__PURE__*/_jsx("div", {
                  className: "skeleton__text skeleton__placeholder"
                })
              }), /*#__PURE__*/_jsx("div", {
                className: "col-xs-2 col-lg-1",
                children: /*#__PURE__*/_jsx("div", {
                  className: "skeleton__text skeleton__placeholder"
                })
              }), /*#__PURE__*/_jsx("div", {
                className: "col-xs-2 col-lg-1",
                children: /*#__PURE__*/_jsx("div", {
                  className: "skeleton__text skeleton__placeholder"
                })
              })]
            })]
          }))]
        })
      })
    });
  }
  return /*#__PURE__*/_jsx("div", {
    "data-cmp": "inventoryListingPlaceholder",
    ref: ref,
    ...rest,
    children: _div2 || (_div2 = /*#__PURE__*/_jsx("div", {
      className: "inventory-listing cursor-pointer display-flex flex-column panel panel-default",
      children: /*#__PURE__*/_jsxs("div", {
        className: "row item-card skeleton__listing skeleton__loading skeleton__fixedheight",
        children: [/*#__PURE__*/_jsx("div", {
          className: "col-xs-12 padding-0",
          children: /*#__PURE__*/_jsx("div", {
            className: "skeleton__image_portrait skeleton__placeholder",
            "data-cmp": "inventoryListingPlaceholderImage"
          })
        }), /*#__PURE__*/_jsxs("div", {
          className: "col-xs-12 padding-4",
          children: [/*#__PURE__*/_jsx("div", {
            className: "row",
            children: /*#__PURE__*/_jsx("div", {
              className: "col-xs-12",
              children: /*#__PURE__*/_jsx("div", {
                className: "skeleton__headline skeleton__placeholder"
              })
            })
          }), /*#__PURE__*/_jsx("div", {
            className: "row",
            children: /*#__PURE__*/_jsx("div", {
              className: "col-xs-6",
              children: /*#__PURE__*/_jsx("div", {
                className: "skeleton__subtext skeleton__placeholder"
              })
            })
          }), /*#__PURE__*/_jsx("div", {
            className: "row",
            children: /*#__PURE__*/_jsx("div", {
              className: "col-xs-11 margin-bottom-1 margin-bottom-sm-2 margin-bottom-lg-1",
              children: /*#__PURE__*/_jsx("div", {
                className: "skeleton__subtext skeleton__placeholder"
              })
            })
          }), /*#__PURE__*/_jsx("div", {
            className: "row",
            children: /*#__PURE__*/_jsx("div", {
              className: "col-xs-4 margin-bottom-2",
              children: /*#__PURE__*/_jsx("div", {
                className: "skeleton__subtext skeleton__placeholder"
              })
            })
          }), /*#__PURE__*/_jsx("div", {
            className: "row",
            children: /*#__PURE__*/_jsx("div", {
              className: "col-xs-8",
              children: /*#__PURE__*/_jsx("div", {
                className: "skeleton__headline skeleton__placeholder"
              })
            })
          }), /*#__PURE__*/_jsx("div", {
            className: "row",
            children: /*#__PURE__*/_jsx("div", {
              className: "col-xs-7 margin-bottom-3 margin-bottom-sm-6 margin-bottom-lg-3",
              children: /*#__PURE__*/_jsx("div", {
                className: "skeleton__text skeleton__placeholder"
              })
            })
          })]
        })]
      })
    }))
  });
}
export default /*#__PURE__*/React.forwardRef(InventoryListingPlaceholder);